import {
  TOPIC_SELECT,
  TOPIC_UNSELECT,
  TOPIC_LIST_UPDATE,
  TOPIC_REQUEST_FAILURE,
} from '../actions/topic';
import TopicState from '../types/topic';

const defaultState: TopicState = {
  available: [],
  suggested: [],
  history: [],
  selections: [],
  count: 0,
  selected: 0,
};

export default function topic(state: TopicState = defaultState, action) {
  if (!state.hydrated) {
    state = { ...defaultState, ...state, hydrated: true };
  }

  switch (action.type) {
    case TOPIC_SELECT:
      return topicSelect(state, action);
    case TOPIC_UNSELECT:
      return topicUnselect(state, action);
    case TOPIC_LIST_UPDATE:
      return topicListUpdate(state, action);
    case TOPIC_REQUEST_FAILURE:
      return topicRequestFailure(state, action);
    default:
      return state;
  }
}

function topicSelect(state: TopicState, action) {
  const newSelections: number[] = [...state.selections, action.newTopicId];

  return {
    ...state,
    selections: newSelections,
    selected: newSelections.length,
  };
}

function topicUnselect(state: TopicState, action) {
  const newSelections: number[] = state.selections.filter(id => action.oldTopicId !== id);

  return {
    ...state,
    selections: newSelections,
    selected: newSelections.length,
  };
}

function topicListUpdate(state: TopicState, action) {
  const newHistory: number[][] = [...state.history, action.newTopicIds];

  return {
    ...state,
    available: action.availableTopics,
    suggested: action.newTopicIds,
    count: action.availableTopics.length,
    history: newHistory,
  };
}

function topicRequestFailure(state: TopicState, action) {
  if (action.requestType === TOPIC_SELECT && action.topicId !== undefined) {
    const revertedSelections = state.selections.filter(id => id !== action.topicId);
    return {
      ...state,
      selections: revertedSelections,
      selected: revertedSelections.length,
    };
  }

  if (action.requestType === TOPIC_UNSELECT && action.topicId !== undefined) {
    const revertedSelections = state.selections.includes(action.topicId)
      ? state.selections
      : [...state.selections, action.topicId];
    return {
      ...state,
      selections: revertedSelections,
      selected: revertedSelections.length,
    };
  }

  return state;
}
